// Fase 21A: solicitudes de anulación — un EMPLOYEE nunca anula compras/gastos/ventas otros/cortes
// directamente, en su lugar pide aquí la anulación de un registro CONFIRMED/CLOSED que él mismo
// creó en su tienda; un MANAGER/OWNER la aprueba (aplica la anulación real del módulo
// correspondiente) o la rechaza. Nunca toca Loyverse, nunca ejecuta SALE_OUT.
// F2: INVENTORY_WASTE = la merma que el empleado registró hoy (solo se pide ANULAR, no modificar).
export type VoidRequestTargetType = 'PURCHASE' | 'OTHER_EXPENSE' | 'OTHER_SALE' | 'SHIFT_CLOSE' | 'INVENTORY_WASTE';

export type VoidRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';

// Solicitud de cambio: VOID (anular) | MODIFY (modificar). Default VOID = comportamiento previo.
export type VoidRequestType = 'VOID' | 'MODIFY';

export interface VoidRequestItem {
  id: string;
  storeId: string;
  storeName: string;
  targetType: VoidRequestTargetType;
  targetId: string;
  targetLabel: string | null;
  type: VoidRequestType;
  requestedChange: string | null;
  requestedByUserId: string;
  requestedByName: string | null;
  requestedAt: string;
  reason: string;
  status: VoidRequestStatus;
  reviewedByUserId: string | null;
  reviewedByName: string | null;
  reviewedAt: string | null;
  reviewNotes: string | null;
  appliedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface VoidRequestListResponse {
  items: VoidRequestItem[];
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export interface VoidRequestListFilters {
  status?: VoidRequestStatus;
  storeId?: string;
  targetType?: VoidRequestTargetType;
  requestedByUserId?: string;
  dateFrom?: string;
  dateTo?: string;
  mine?: boolean;
  limit?: number;
  offset?: number;
}

export interface CreateVoidRequestInput {
  targetType: VoidRequestTargetType;
  targetId: string;
  reason: string;
  type?: VoidRequestType;
  requestedChange?: string;
}

export interface ApproveVoidRequestInput {
  confirm: true;
  reviewNotes?: string | null;
}

export interface RejectVoidRequestInput {
  reviewNotes: string;
}

export const VOID_REQUEST_TARGET_TYPE_LABELS: Record<VoidRequestTargetType, string> = {
  PURCHASE: 'Compra',
  OTHER_EXPENSE: 'Gasto',
  OTHER_SALE: 'Venta o ingreso',
  SHIFT_CLOSE: 'Corte de turno',
  INVENTORY_WASTE: 'Merma',
};

export const VOID_REQUEST_STATUS_LABELS: Record<VoidRequestStatus, string> = {
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  CANCELLED: 'Cancelada',
};
